import { atom } from 'jotai';

export const searchCreatorPendingAtom = atom(false);
